import { useState } from "react";
import {
  DefectStatus,
  DefectStatusEntry,
  PunchlistText,
  StatusButton,
  StatusIcon,
  StatusModal,
  StatusSelect,
} from "../..";
import { Button, Modal } from "imagine-ui";
import { useTranslation } from "react-i18next";
import { UserRole } from "imagine-users";

interface Props {
  status: DefectStatus;
  mode: "select" | "modal";
  readonly?: boolean;
  onChange?: (status: DefectStatus) => void;
  onSave?: (status: DefectStatusEntry) => void;
  className?: string;
  userRole: UserRole;
}

export const StatusIconSelect = (props: Props) => {
  const [showEditor, setShowEditor] = useState(false);
  const { t } = useTranslation();
  const select = (status: DefectStatus) => {
    if (props.onChange) {
      props.onChange(status);
    }
    setShowEditor(false);
  };

  const updateStatus = (status: DefectStatusEntry) => {
    setShowEditor(false);
    if (props.onSave) {
      props.onSave(status);
    }
  };

  return (
    <div
      className={
        "row items-y-center " +
        (!props.readonly && props.mode === "select" ? "my-sm--xs " : "") +
        (props.className ? props.className : "")
      }
    >
      <div>
        <StatusIcon status={props.status} className="mr-sm" />
      </div>
      {!props.readonly && props.mode === "select" && (
        <div className="stretch">
          <StatusSelect
            status={props.status}
            onChange={(status) => select(status)}
            className="w-max-300"
          />
        </div>
      )}
      {(props.readonly || props.mode === "modal") && (
        <span>{PunchlistText.getDefectStatusText(props.status)}</span>
      )}
      {props.mode !== "select" && !props.readonly && (
        <Button
          onClick={() => setShowEditor(true)}
          className="ml-sm"
          icon="edit"
          transparent
          size="sm"
        />
      )}
      {showEditor && (
        <StatusModal
          onSave={updateStatus}
          onClose={() => setShowEditor(false)}
          commentMandatory={props.userRole === UserRole.PREMIUM}
          userRole={props.userRole}
        />
      )}
    </div>
  );
};
